module.exports = __webpack_public_path__ + "91433571f154776a1d46c2a287de05d7.svg";